import { render, staticRenderFns } from "./RevaluationView.vue?vue&type=template&id=40cad8a1&scoped=true&"
import script from "./RevaluationView.vue?vue&type=script&lang=ts&"
export * from "./RevaluationView.vue?vue&type=script&lang=ts&"
import style0 from "./RevaluationView.vue?vue&type=style&index=0&id=40cad8a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cad8a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VIcon,VSpacer,VSwitch,VTextField,VTooltip})
